import axios from '../../http/axios/index.js'

// const API_URL = 'https://selfie.cash'
const API_URL = 'https://selfie.cash'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchAllSelfies({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/allSelfies`)
        .then((response) => {
          commit('SET_ALLSELFIES', response.data.allSelfie)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/users/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`${API_URL}/api/management/users/${id}`)
        .then((response) => {
          commit('REMOVE_RECORD', id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateSelfie({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_URL}/api/management/changeSelfieStatus`, { 
          _id: payload._id,
          description: payload.description,
          owner: payload.owner,
          price: payload.price,
          status: payload.status,
          title: payload.title,
          type: payload.type,
          url: payload.url,
          rejectTooltip: payload.rejectTooltip
         })
        .then((res) => {
          commit('UPDATE_SELFIE', { 
            _id: payload._id,
            description: payload.description,
            owner: payload.owner,
            price: payload.price,
            status: payload.status,
            title: payload.title,
            type: payload.type,
            url: payload.url,
            rejectTooltip: payload.rejectTooltip
           })
          this._vm.$vs.notify({
            color: "success",
            title: "Success!",
            text: "Selfie updated successfully",
          });
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  approveRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/api/management/usersApprove/${id}`)
        .then((response) => {
          this._vm.$vs.notify({
            color: "success",
            title: "User Approved",
            text: response.data.message,
          });
          commit('APPROVE_USER', id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  rejectRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/api/management/usersReject/${id}`)
        .then((response) => {
          this._vm.$vs.notify({
            color: "danger",
            title: "User Rejected",
            text: response.data.message,
          });
          commit('REJECT_USER', id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
